import { render, staticRenderFns } from "./SubmitModal.vue?vue&type=template&id=8eb1f588&scoped=true"
import script from "./SubmitModal.vue?vue&type=script&lang=js"
export * from "./SubmitModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitModal.vue?vue&type=style&index=0&id=8eb1f588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb1f588",
  null
  
)

export default component.exports